import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {Card, Text} from 'components/UIKit';
import {CardChart, CardCta, CardHeader, CardMetrics, CardScreenshot} from './components';
import styles from './ListingCard.scss';
import * as locales from './locales';

interface ListingCardProps {
  shop: Shop;
  group?: string;
  loading?: boolean;
  showImage: boolean;
}

export interface ListingCardState {
  chartData: {[date: string]: string};
}

export class ListingCardComponent extends React.Component<
  ListingCardProps & WithI18nProps,
  ListingCardState
> {
  static getDerivedStateFromProps(props) {
    return {
      chartData: (props.shop.shopifyShopRecord.monthByMonthRevenue || []).reduce((memo, month) => {
        memo[month.date] = Math.max(0, month.revenue);
        return memo;
      }, {}),
    };
  }

  constructor(props) {
    super(props);
    this.state = ListingCardComponent.getDerivedStateFromProps(props);
  }

  getShopPath = () => {
    const {shop} = this.props;
    return `/shops/${shop.handle}`;
  };

  handleCardClick = () => {
    location.href = this.getShopPath();
  };

  render() {
    const {shop, group, loading, showImage, i18n} = this.props;
    const {chartData} = this.state;

    return (
      <Card
        contentClassName={classNames(styles.listingCard, loading && styles.loading)}
        component="li"
        onClick={this.handleCardClick}
      >
        <div className={styles.Visual}>
          {showImage ? (
            <CardScreenshot
              shop={shop}
              alt={i18n.translate('screenshotAlt', {shopTitle: shop.title})}
            />
          ) : (
            <CardChart
              id={group + shop.title}
              data={chartData}
              title={i18n.translate('totalRevenue')}
              total={shop.shopifyShopRecord.totalRevenue}
              loading={loading}
            />
          )}
        </div>
        <CardHeader shop={shop} shopPath={this.getShopPath()} />
        <div className={styles.pitch}>
          <Text
            text={shop.marketplaceDescription || i18n.translate('pitchPlaceholder')}
            secondary={!shop.marketplaceDescription}
            resetMargin
            component="p"
            type="small"
          />
        </div>
        <CardMetrics shop={shop} />
        <CardCta shop={shop} shopPath={this.getShopPath()} />
      </Card>
    );
  }
}

export const ListingCard = withI18n({
  id: 'ListingCard',
  fallback: locales.en,
})(ListingCardComponent);
